/**
 * El corte entre pantalla angosta y pantalla ancha, en un solo lugar.
 *
 * *** Lo decide CSS, no JavaScript. *** Nexo expone `getIsMobileDevice`, y es tentador
 * usarlo. No: leyendo el bundle de `@tiendanube/nexo` 1.3.1, `asyncAction` resuelve
 * únicamente cuando llega el mensaje de respuesta del panel y **no tiene timeout**. Si el
 * shell no contesta —una versión vieja del admin, un `postMessage` perdido— la promesa no
 * resuelve nunca. Colgar el layout de eso cambia "tabla incómoda" por "pantalla en
 * blanco", que es mucho peor. Un layout que se adapta solo no necesita que nadie conteste.
 *
 * El corte es `md`, el breakpoint de Nimbus: **672px**. Abajo entra un celular en vertical
 * —375px es el piso real contra el que se probó—, arriba entra una tabla.
 *
 * *** Los dos árboles se montan siempre y uno queda en `display: none`. *** Es a
 * propósito. Los datos ya están en memoria, así que no hay un pedido de más; y no hay
 * salto de layout al resolverse una medición, porque no hay medición. El costo es marcado
 * duplicado en el DOM, que para una tabla paginada de 50 filas no se siente.
 *
 * Sólo para tablas y listas. Nunca para envolver campos de formulario: duplicaría `id`s y
 * rompería los `label htmlFor`.
 */

import { Box } from '@nimbus-ds/components';
import type { ReactElement, ReactNode } from 'react';

/** Se ve de 672px para arriba. Acá van las tablas. */
export function EnPantallaAncha({ children }: { readonly children: ReactNode }): ReactElement {
  return <Box display={{ xs: 'none', md: 'block' }}>{children}</Box>;
}

/** Se ve por debajo de 672px. Acá van las tarjetas. */
export function EnPantallaAngosta({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement {
  return (
    <Box display={{ xs: 'flex', md: 'none' }} flexDirection="column" gap="2">
      {children}
    </Box>
  );
}
